import { render } from "./Indicacao.vue?vue&type=template&id=40c091c2&scoped=true"
import script from "./Indicacao.vue?vue&type=script&lang=js"
export * from "./Indicacao.vue?vue&type=script&lang=js"

import "./Indicacao.vue?vue&type=style&index=0&id=40c091c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c091c2"]])

export default __exports__